import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = {
  key: 2,
  class: "mb10 rad6 label pad5 mt10 with_white_bg"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { class: "appointmentContent" }
const _hoisted_10 = { class: "appointmentContentInner posRe" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "fs20 fw600 fl"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "fs24 fw600 arial",
  style: {"margin-top":"10px"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "fs16 fw600" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 2 }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "fs12" }
const _hoisted_25 = {
  key: 1,
  class: "fs16",
  style: {"margin-top":"10px"}
}
const _hoisted_26 = ["src"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["href"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb10" }, null, -1)
const _hoisted_31 = {
  class: "appointmentAttendeesContent",
  style: {"margin-top":"30px"}
}
const _hoisted_32 = { class: "fs12 ddgrey fw600" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = {
  key: 0,
  style: {"margin-top":"6px"}
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = {
  key: 1,
  class: "fs12 ddgrey fw600 fl mt3 mr4"
}
const _hoisted_39 = ["src"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_41 = {
  key: 3,
  class: "mt6"
}
const _hoisted_42 = {
  key: 0,
  class: "greenBg rad4 posAb",
  style: {"width":"8px","height":"8px","z-index":"1","left":"-3px"}
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb10" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = { key: 1 }
const _hoisted_46 = ["href"]
const _hoisted_47 = ["src"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", {
  class: "circle_button fw600 posAb",
  style: {"top":"160px","left":"40px"}
}, "会議場所を設定", -1)
const _hoisted_50 = ["src"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = { class: "w100 mt20" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = {
  key: 0,
  class: "pad10 rad8",
  style: {"border":"1px solid #ddd"}
}
const _hoisted_55 = ["src"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "fs12 dgrey" }, "オーナーが所属するメンバーのみが閲覧できます。", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_59 = {
  class: "mc centered",
  style: {"width":"170px"}
}
const _hoisted_60 = ["src"]
const _hoisted_61 = ["src"]
const _hoisted_62 = ["src"]
const _hoisted_63 = ["src"]
const _hoisted_64 = { key: 0 }
const _hoisted_65 = ["src"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw600" }, " カスタム確定する", -1)
const _hoisted_67 = ["src"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw600" }, "調整カレンダーを変更", -1)
const _hoisted_69 = ["src"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw600" }, " 担当者を変更", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_72 = {
  key: 1,
  class: "fs13 fw600 mt10 mb30"
}
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { class: "nodisp" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "fs12 fw400" }, "調整カレンダーの共有解除", -1)
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_79 = { key: 1 }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", {
  class: "fl",
  style: {"width":"200px"}
}, [
  /*#__PURE__*/_createTextVNode(" あなたは日程調整参加者です。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("調整カレンダーを共有して、調整しましょう！ ")
], -1)
const _hoisted_81 = ["src"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw600" }, " 調整カレンダーを共有", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle circle_button fl fs10 blueAround fw600",
  style: {"padding":"2px 4px","box-shadow":"0 0 0","color":"#333","height":"44px","border-radius":"0 10px 10px 0"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "caret" })
], -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl",
  style: {"margin-top":"5px","margin-left":"8px"}
}, " 他の調整カレンダーを選択 ", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_89 = { key: 2 }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_91 = { class: "w100 pad20 fw600 mt20 centered llgreyBg" }
const _hoisted_92 = {
  style: {"line-height":"23px"},
  class: "mt10 centered w100"
}
const _hoisted_93 = { class: "fs12 ddgrey fw600" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_95 = { class: "fs18 fw600 ddgrey" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", { class: "ml10" }, "様からのメッセージ", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_98 = {
  class: "fs13 kaigyo rad8 mt5",
  style: {"padding":"30px 0px"}
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("p", { class: "header_title centered fs24" }, "現在、他の方が調整中です", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs14 fw600" }, "現在、他の方が調整中です。順番が回ってくるまでお待ち下さい。"),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_104 = [
  _hoisted_100,
  _hoisted_101,
  _hoisted_102,
  _hoisted_103
]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("p", { class: "header_title centered fs24" }, "現在このページは利用できません", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs14 fw600" }, "現在このページはご利用いただけません。ページオーナーにお問い合わせください。"),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_109 = [
  _hoisted_105,
  _hoisted_106,
  _hoisted_107,
  _hoisted_108
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_IconStar = _resolveComponent("IconStar")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ModalEditAppointment = _resolveComponent("ModalEditAppointment")!
  const _component_InputLocationModal = _resolveComponent("InputLocationModal")!
  const _component_ModalSelectAstags = _resolveComponent("ModalSelectAstags")!
  const _component_ModalPastAppointments = _resolveComponent("ModalPastAppointments")!
  const _component_AnsweredFormModal = _resolveComponent("AnsweredFormModal")!
  const _component_ChangeMeetingAttendeesGroupModal = _resolveComponent("ChangeMeetingAttendeesGroupModal")!
  const _component_EditAttendeesModal = _resolveComponent("EditAttendeesModal")!
  const _component_AlertModal = _resolveComponent("AlertModal")!
  const _component_AlertWithTextareaModal = _resolveComponent("AlertWithTextareaModal")!
  const _component_CalendarEventModal = _resolveComponent("CalendarEventModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.rm.currentRoom && _ctx.type && _ctx.type != `na` && _ctx.rm.designType() == `normal`)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(`ScheduleFixContent ofh ${_ctx.isSP ? `pad20 with_white_bg` : `pad20`} posRe`)
      }, [
        (_ctx.rm.currentRoom)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 0,
              text: "コピーしました!",
              trigger: "manual",
              modelValue: _ctx.showTip,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showTip) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  class: "fl fs13 label skyblueBorder",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyPublicId && _ctx.copyPublicId(...args)))
                }, _toDisplayString(_ctx.rm.currentRoom.public_id), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (!_ctx.isPreview && !_ctx.Util.isPublic() && _ctx.canCreateOrEditAppo)
          ? (_openBlock(), _createElementBlock("section", {
              key: 1,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editScheduleInfo && _ctx.editScheduleInfo(...args))),
              class: _normalizeClass(`lgreyBg rad20 fr`),
              style: {"height":"44px","width":"44px"}
            }, [
              _withDirectives(_createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
                width: "24",
                height: "24",
                class: "pointer mt10 ml10"
              }, null, 8, _hoisted_1), [
                [_directive_tooltip, `編集`]
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_2,
        (!_ctx.isPreview && !_ctx.Util.isPublic() && (_ctx.rm.currentRoom.is_owner_group || _ctx.rm.userInfo.group_status >= 10000))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_IconStar, {
                starred: _ctx.checkStarred,
                onPushStar: _ctx.pushStar,
                class: "fl mr5"
              }, null, 8, ["starred", "onPushStar"]),
              _createElementVNode("div", {
                class: "fl fs12 mt5 dgrey pointer",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pushStar && _ctx.pushStar(...args)))
              }, _toDisplayString(_ctx.checkStarred ? `お気に入りから削除` : `お気に入りに追加`), 1),
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        (_ctx.rm.currentRoom.appointments && _ctx.rm.currentRoom.appointments.length > 0)
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              class: "fl fs13 label grey pointer",
              style: {"border-bottom":"1px solid #efefef","line-height":"18px"},
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showPastAppointments && _ctx.showPastAppointments(...args)))
            }, "調整一覧"))
          : _createCommentVNode("", true),
        _hoisted_5,
        _createElementVNode("div", {
          class: "centered mt20",
          style: _normalizeStyle({ top: _ctx.isSP ? `80px` : `` })
        }, [
          (_ctx.canCreateOrEditAppo)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "skyblue fs13 fw600 pointer centered",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addNewAppo && _ctx.addNewAppo(...args)))
              }, " + 同じメンバーで新規の日程調整を開始 "))
            : _createCommentVNode("", true)
        ], 4),
        _hoisted_6,
        _hoisted_7,
        (_ctx.currentAppo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    (_ctx.Util.isPresent(_ctx.rm.currentRoom.appeal_content) && _ctx.rm.currentRoom.appeal_content.title)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, "■ " + _toDisplayString(_ctx.currentAppo.name), 1))
                  ]),
                  _hoisted_13,
                  (_ctx.currentAppo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_ctx.currentAppo.status == 10)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                          : (_ctx.currentAppo.status == -1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                (!_ctx.isSP)
                                  ? (_openBlock(), _createElementBlock("del", _hoisted_17, _toDisplayString(_ctx.currentAppo.jp_format) + "  (" + _toDisplayString(_ctx.currentAppo.duration) + _toDisplayString(_ctx.$t(`schedule.min`)) + ")", 1))
                                  : (_openBlock(), _createElementBlock("del", _hoisted_18, [
                                      _createTextVNode(_toDisplayString(_ctx.currentAppo.jp_format) + " ", 1),
                                      _hoisted_19,
                                      _createElementVNode("span", _hoisted_20, [
                                        _createElementVNode("img", {
                                          src: _ctx.$getAssetImageUrl(`/assets/icons/watch2.png`),
                                          width: "16",
                                          height: "16",
                                          class: "fl mr7 mt6 ml2"
                                        }, null, 8, _hoisted_21),
                                        _createTextVNode(" " + _toDisplayString(_ctx.currentAppo.duration) + _toDisplayString(_ctx.$t(`schedule.min`)), 1)
                                      ])
                                    ]))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/watch2.png`),
                                  width: "16",
                                  height: "16",
                                  class: "fl mr7 mt6 ml2"
                                }, null, 8, _hoisted_23),
                                _createTextVNode(" " + _toDisplayString(_ctx.currentAppo.duration) + " ", 1),
                                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t(`schedule.min`)), 1)
                              ]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.currentAppo.location_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/mappin.png`),
                          width: "18",
                          height: "18",
                          class: "fl mr5"
                        }, null, 8, _hoisted_26),
                        (_ctx.Util.isUrl(_ctx.currentAppo.location_name))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("a", {
                                class: "fs12 skyblue",
                                href: `${_ctx.currentAppo.location_name}`,
                                target: "_blank"
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.currentAppo.location_name), 1)
                              ], 8, _hoisted_28)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.currentAppo.location_name), 1)
                            ])),
                        _hoisted_30
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t(`user_group.owner`)), 1),
                    _hoisted_33,
                    (_ctx.owner)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("span", null, [
                            _createVNode(_component_UserIcon, {
                              width: 48,
                              canEdit: false,
                              member: _ctx.owner,
                              showTooltip: false,
                              class: "fl mr5 posRe"
                            }, null, 8, ["member"])
                          ]),
                          _hoisted_35
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_36,
                    _hoisted_37,
                    (!_ctx.Util.isPublic())
                      ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_ctx.$t(`user_group.members`)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.rm.currentRoom.is_owner_group && !_ctx.isPreview && !_ctx.Util.isPublic())
                      ? (_openBlock(), _createElementBlock("section", {
                          key: 2,
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.editAttendees && _ctx.editAttendees(...args))),
                          class: _normalizeClass(`lgreyBg rad10 fl`),
                          style: {"height":"22px","width":"22px"}
                        }, [
                          _withDirectives(_createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
                            width: "12",
                            height: "12",
                            class: "pointer ml5"
                          }, null, 8, _hoisted_39), [
                            [_directive_tooltip, `編集`]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_40,
                    (!_ctx.Util.isPublic() && _ctx.Util.isPresent(_ctx.attendees))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendees, (mem, memindex) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: memindex,
                                class: _normalizeClass(_ctx.isSP ? `fs11 posRe` : `fs11 fl mr2 posRe`)
                              }, [
                                (mem.shared)
                                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_42, null, 512)), [
                                      [_directive_tooltip, `日程候補提案済みのユーザーです`]
                                    ])
                                  : _createCommentVNode("", true),
                                _createVNode(_component_UserIcon, {
                                  width: 48,
                                  canEdit: false,
                                  member: mem,
                                  showTooltip: true,
                                  class: "fl mr5 posRe mb5"
                                }, null, 8, ["member"])
                              ], 2))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_43
              ]),
              (_ctx.currentAppo.location_name)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`appoLocationImage mt20 ${_ctx.isSP ? `centered` : `centered`}`),
                    style: _normalizeStyle({
                    width: _ctx.isSP ? `` : `320px`,
                    marginLeft: _ctx.isSP ? `` : `calc( -20px + ( ${_ctx.contentWidth}px - 320px)/2 )`,
                })
                  }, [
                    (
                        !_ctx.Util.isPublic() &&
                        !_ctx.isPreview &&
                        (_ctx.currentAppo.location_select_type.includes(`registrable`) || _ctx.currentAppo.status == 10) &&
                        _ctx.canCreateOrEditAppo
                    )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(`fs12 skyblue pointer fr`),
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openLocationModal && _ctx.openLocationModal(...args))),
                          style: {"margin-right":"80px"}
                        }, _toDisplayString(_ctx.$t(`title.change_location`)), 1))
                      : _createCommentVNode("", true),
                    _hoisted_44,
                    (!_ctx.Util.isUrl(_ctx.LocationTag.getAddressFromCurrentAppo(_ctx.currentAppo)))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("a", {
                            href: _ctx.locationHref(),
                            target: "_blank",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goGmap && _ctx.goGmap(...args)))
                          }, [
                            _createElementVNode("img", {
                              src: 
                                _ctx.$getAssetImageUrl(
                                    _ctx.Util.getURLFromAddress(_ctx.LocationTag.getAddressFromCurrentAppo(_ctx.currentAppo, true), `320x320`)
                                )
                            ,
                              style: {"height":"90%","width":"90%"}
                            }, null, 8, _hoisted_47)
                          ], 8, _hoisted_46)
                        ]))
                      : _createCommentVNode("", true)
                  ], 6))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(`appoLocationImage posRe pointer ${_ctx.isSP ? `centered` : `centered`}`),
                    style: _normalizeStyle({
                    width: _ctx.isSP ? `` : `320px`,
                    marginLeft: _ctx.isSP ? `` : `calc( -20px + ( ${_ctx.contentWidth}px - 320px)/2 )`,
                }),
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openLocationModal && _ctx.openLocationModal(...args)))
                  }, [
                    (!_ctx.Util.isPublic() && _ctx.canCreateOrEditAppo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/link/illust_bg_image.png`),
                            style: {"opacity":"0.2","height":"80%"}
                          }, null, 8, _hoisted_50)
                        ]))
                      : _createCommentVNode("", true)
                  ], 6)),
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                (_ctx.type && _ctx.rm.currentRoom && _ctx.rm.currentRoom.room_type == `parent_room`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      (_ctx.rm.currentRoom.is_owner_group)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/eye.png`),
                                class: "fl",
                                width: "18",
                                height: "18"
                              }, null, 8, _hoisted_55),
                              _createTextVNode("  "),
                              _hoisted_56
                            ]),
                            _hoisted_57,
                            _hoisted_58,
                            _createElementVNode("div", _hoisted_59, [
                              (_ctx.Util.isPresent(_ctx.rm.currentRoom.members.find(m => [`done`].includes(m.answered_status))))
                                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "rad8 pointer centered circle_button blueAround fs16 fl",
                                    style: {"padding":"8px 14px","width":"56px"},
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.clickFormMember(_ctx.rm.currentRoom.members.find(m => [`done`].includes(m.answered_status)))))
                                  }, [
                                    _createElementVNode("img", {
                                      src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
                                      width: "24",
                                      height: "24",
                                      style: {}
                                    }, null, 8, _hoisted_60)
                                  ])), [
                                    [_directive_tooltip, `フォーム確認`]
                                  ])
                                : _createCommentVNode("", true),
                              (_ctx.showChatContent)
                                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.changeChatStatus && _ctx.changeChatStatus(...args))),
                                    class: "rad8 pointer centered circle_button blueAround fs16 fl",
                                    style: {"padding":"8px 14px","width":"56px"}
                                  }, [
                                    _createElementVNode("img", {
                                      src: _ctx.$getAssetImageUrl(`/assets/icons/chat.png`),
                                      width: "24",
                                      height: "24",
                                      class: ""
                                    }, null, 8, _hoisted_61)
                                  ])), [
                                    [_directive_tooltip, 
                                    `${
                                        _ctx.rm.currentRoom.room_setting && _ctx.rm.currentRoom.room_setting.use_chat
                                            ? `チャット非表示に変更`
                                            : `チャット表示に変更`
                                    }`
                                ]
                                  ])
                                : _createCommentVNode("", true),
                              _withDirectives((_openBlock(), _createElementBlock("div", {
                                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.changeProgressesStatus && _ctx.changeProgressesStatus(...args))),
                                class: "rad8 pointer centered circle_button blueAround fs16 fl",
                                style: {"padding":"8px 14px","width":"56px"}
                              }, [
                                (_ctx.rm.currentRoom.progress_status == `stay`)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: _ctx.$getAssetImageUrl(`/assets/icons/status_play.png`),
                                      width: "24",
                                      height: "24",
                                      class: ""
                                    }, null, 8, _hoisted_62))
                                  : (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: _ctx.$getAssetImageUrl(`/assets/icons/status_suspend.png`),
                                      width: "24",
                                      height: "24",
                                      class: ""
                                    }, null, 8, _hoisted_63))
                              ])), [
                                [_directive_tooltip, 
                                    `${
                                        _ctx.rm.currentRoom.progress_status == `stay`
                                            ? `現在「日程表示しない」中です`
                                            : `日程を表示しない状態に変更`
                                    }`
                                ]
                              ])
                            ]),
                            ((_ctx.rm.currentRoom.is_owner || _ctx.rm.currentRoom.is_shared) && _ctx.currentAppo.status == 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                  _createElementVNode("section", {
                                    class: "pointer centered circle_button blueAround fs16 mt10",
                                    style: {"width":"190px","height":"44px","padding":"9px 8px"},
                                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.clickFixDateFromOwner && _ctx.clickFixDateFromOwner(...args)))
                                  }, [
                                    _createElementVNode("img", {
                                      src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_himekuri_grey.png`),
                                      width: "23",
                                      height: "23",
                                      style: {"margin-top":"0px"}
                                    }, null, 8, _hoisted_65),
                                    _hoisted_66
                                  ]),
                                  (_ctx.currentAppo.required_owner_participation && _ctx.rm.currentRoom.is_owner)
                                    ? (_openBlock(), _createElementBlock("section", {
                                        key: 0,
                                        class: "pointer centered circle_button blueAround fs16 mt10",
                                        style: {"width":"190px","border-radius":"8px","height":"44px","padding":"9px 8px"},
                                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.changeCalendar && _ctx.changeCalendar(...args)))
                                      }, [
                                        _createElementVNode("img", {
                                          src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_himekuri_grey.png`),
                                          width: "23",
                                          height: "23",
                                          style: {"margin-top":"0px"}
                                        }, null, 8, _hoisted_67),
                                        _hoisted_68
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.canChangeMag)
                              ? (_openBlock(), _createElementBlock("section", {
                                  key: 1,
                                  class: "pointer centered circle_button blueAround fs16 mt10",
                                  style: {
                                width: `190px`,
                                height: `44px`,
                                padding: `9px 8px`,
                            },
                                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.clickChangeMag && _ctx.clickChangeMag(...args)))
                                }, [
                                  _createElementVNode("img", {
                                    src: _ctx.$getAssetImageUrl(`/assets/icons/waaq_members.png`),
                                    width: "23",
                                    height: "18",
                                    style: {"margin-top":"-1px"}
                                  }, null, 8, _hoisted_69),
                                  _hoisted_70
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_71
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                            false
                              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                  (_ctx.pdm.didShare())
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                        _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.userType), 1),
                                        (
                                        (_ctx.canCreateOrEditAppo && [`user`, `logged_in`].includes(_ctx.userType)) ||
                                        _ctx.rm.userInfo.group_status >= 10000
                                    )
                                          ? (_openBlock(), _createElementBlock("section", {
                                              key: 0,
                                              class: "pointer centered circle_button blueAround fs16 fl",
                                              style: {"border-radius":"8px","padding":"4px 16px","height":"37px"},
                                              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.unshareRestrictCalendar && _ctx.unshareRestrictCalendar(...args)))
                                            }, _hoisted_77))
                                          : _createCommentVNode("", true),
                                        _hoisted_78
                                      ]))
                                    : (_ctx.showShareButton())
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                          _hoisted_80,
                                          _createElementVNode("section", {
                                            class: "pointer centered circle_button blueAround fs16 fl",
                                            style: _normalizeStyle({
                                        borderRadius:
                                            _ctx.Util.isPresent(_ctx.rm.astags) && (_ctx.rm.astags || []).length >= 2
                                                ? `10px 0px 0px 10px`
                                                : `8px`,
                                        width: `190px`,
                                        height: `44px`,
                                        padding: `9px 8px`,
                                    }),
                                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.shareRestrictCalendar && _ctx.shareRestrictCalendar(...args)))
                                          }, [
                                            _createElementVNode("img", {
                                              src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_himekuri_grey.png`),
                                              width: "23",
                                              height: "23",
                                              style: {"margin-top":"0px"}
                                            }, null, 8, _hoisted_81),
                                            _hoisted_82
                                          ], 4),
                                          ((_ctx.rm.astags || []).length >= 2)
                                            ? (_openBlock(), _createBlock(_component_Dropdown, {
                                                key: 0,
                                                ref: "dropdown",
                                                class: "fl"
                                              }, {
                                                dropdown: _withCtx(() => [
                                                  _createElementVNode("li", {
                                                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.shareAnotherAstag && _ctx.shareAnotherAstag(...args))),
                                                    class: "fs12 pointer fw600 pad10",
                                                    style: {"line-height":"40px"}
                                                  }, _hoisted_86)
                                                ]),
                                                default: _withCtx(() => [
                                                  _hoisted_83
                                                ]),
                                                _: 1
                                              }, 512))
                                            : _createCommentVNode("", true),
                                          _hoisted_87
                                        ]))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_88
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isSP && _ctx.rm.currentRoom && _ctx.currentAppo.memo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                    _hoisted_90,
                    _createElementVNode("div", _hoisted_91, [
                      (_ctx.rm.currentRoom.owner)
                        ? (_openBlock(), _createBlock(_component_UserIcon, {
                            key: 0,
                            width: 62,
                            canEdit: false,
                            member: _ctx.rm.currentRoom.owner,
                            class: ""
                          }, null, 8, ["member"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("span", _hoisted_93, _toDisplayString(_ctx.rm.currentRoom.owner.company_name ? _ctx.rm.currentRoom.owner.company_name : ` `), 1),
                        _hoisted_94,
                        _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.rm.currentRoom.owner.name), 1),
                        _hoisted_96
                      ])
                    ]),
                    _hoisted_97,
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.currentAppo.memo), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ModalEditAppointment, {
          appoStatus: _ctx.appoStatus,
          onHide: _ctx.hideEditAppointmentModal
        }, null, 8, ["appoStatus", "onHide"]),
        (!_ctx.Util.isPublic())
          ? (_openBlock(), _createBlock(_component_InputLocationModal, {
              key: 5,
              appo: _ctx.appo
            }, null, 8, ["appo"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ModalSelectAstags, {
          onSelectEnd: _ctx.selectEnd,
          showAddNewButton: false,
          fromAstag: _ctx.astag
        }, null, 8, ["onSelectEnd", "fromAstag"]),
        _createVNode(_component_ModalPastAppointments, {
          room: _ctx.rm.currentRoom
        }, null, 8, ["room"]),
        _createVNode(_component_AnsweredFormModal, {
          member: _ctx.member,
          room: _ctx.rm.currentRoom,
          onUpdateMember: _ctx.updateMember
        }, null, 8, ["member", "room", "onUpdateMember"]),
        _createVNode(_component_ChangeMeetingAttendeesGroupModal),
        _createVNode(_component_EditAttendeesModal),
        _createVNode(_component_AlertModal, {
          ref: "AlertModal",
          title: _ctx.alertTitle,
          text: _ctx.alertText,
          okButtonName: `変更`,
          hideCancelButton: false,
          onClickOK: _ctx.clickOK,
          onClickCancel: _ctx.clickCancel
        }, null, 8, ["title", "text", "onClickOK", "onClickCancel"]),
        _createVNode(_component_AlertWithTextareaModal, {
          ref: "AlertWithTextareaModal",
          title: _ctx.alertTitle,
          text: _ctx.alertText,
          okButtonName: `変更`,
          room: _ctx.rm.currentRoom,
          onClickOK: _ctx.clickOK,
          onClickCancel: _ctx.clickCancel
        }, null, 8, ["title", "text", "room", "onClickOK", "onClickCancel"]),
        _createVNode(_component_CalendarEventModal, {
          onCreatedEvent: _ctx.createdEvent,
          type: `custom_fix`
        }, null, 8, ["onCreatedEvent"]),
        _hoisted_99
      ], 2))
    : (_ctx.type == `na` && _ctx.naType == `parg_not_turn`)
      ? (_openBlock(), _createElementBlock("section", {
          key: 1,
          class: _normalizeClass(`ScheduleFixContent NotAvailable with_white_bg ofh ${_ctx.isSP ? `pad20` : `pad40`} rad8`)
        }, _hoisted_104, 2))
      : (_ctx.type == `na`)
        ? (_openBlock(), _createElementBlock("section", {
            key: 2,
            class: _normalizeClass(`ScheduleFixContent NotAvailable with_white_bg ofh ${_ctx.isSP ? `pad20` : `pad40`} rad8`)
          }, _hoisted_109, 2))
        : _createCommentVNode("", true)
}